import type { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_REQUEST_ID_FOR_CONTRACT_ID_ASYNC,
    Actions.GET_REQUEST_ID_FOR_CONTRACT_ID_SUCCESS,
    Actions.GET_REQUEST_ID_FOR_CONTRACT_ID_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.GET_REQUEST_ID_FOR_CONTRACT_ID_ASYNC:
    case Actions.GET_REQUEST_ID_FOR_CONTRACT_ID_SUCCESS:
    case Actions.GET_REQUEST_ID_FOR_CONTRACT_ID_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
